export default "__VITE_ASSET__CLu6d2DR__"